/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Source
 */
export interface Source {
    /**
     * 
     * @type {number}
     * @memberof Source
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Source
     */
    date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Source
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof Source
     */
    dataTypes?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Source
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Source
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the Source interface.
 */
export function instanceOfSource(value: object): value is Source {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SourceFromJSON(json: any): Source {
    return SourceFromJSONTyped(json, false);
}

export function SourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Source {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'count': json['count'] == null ? undefined : json['count'],
        'dataTypes': json['data_types'] == null ? undefined : json['data_types'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function SourceToJSON(json: any): Source {
      return SourceToJSONTyped(json, false);
  }

  export function SourceToJSONTyped(value?: Omit<Source, 'id'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString().substring(0,10)),
        'count': value['count'],
        'data_types': value['dataTypes'],
    };
}

